export const TOKEN_KEY = 'app_token';
export const LEGACY_TOKEN_KEY = 'token';
export const USER_INFO_KEY = 'userInfo';

export type AppUserInfo = {
  nickName?: string;
  avatar?: string;
  phone?: string;
  storeId?: string | number;
  identityType?: string | number;
  companyId?: string | number;
  userId?: string | number;
  agentId?: string | number;
  branchId?: string | number;
  deptName?: string;
  branchName?: string;
  status?: string | number;
  [key: string]: unknown;
};

export function getToken(): string {
  return (
    localStorage.getItem(TOKEN_KEY) ||
    localStorage.getItem(LEGACY_TOKEN_KEY) ||
    ''
  );
}

export function setToken(token: string): void {
  const value = String(token || '').trim();
  if (!value) {
    clearToken();
    return;
  }
  localStorage.setItem(TOKEN_KEY, value);
  localStorage.setItem(LEGACY_TOKEN_KEY, value);
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(LEGACY_TOKEN_KEY);
}

export function getUserInfo(): AppUserInfo | null {
  try {
    const raw = localStorage.getItem(USER_INFO_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? (parsed as AppUserInfo) : null;
  } catch {
    return null;
  }
}

export function setUserInfo(info: AppUserInfo | null): void {
  if (!info) {
    localStorage.removeItem(USER_INFO_KEY);
    return;
  }
  localStorage.setItem(USER_INFO_KEY, JSON.stringify(info));
}

export function clearAuthStorage(): void {
  clearToken();
  localStorage.removeItem(USER_INFO_KEY);
}

export function isLoggedIn(): boolean {
  const token = getToken();
  const user = getUserInfo();
  return Boolean(token && user?.userId);
}
